module.exports = __webpack_public_path__ + "static/5-why-me-1913ea0cfe24f57319728a66d2883d1e.svg";